import React, { useEffect, useState } from 'react';
import { PAYWALL_BACKDROP_Z_INDEX, PAYWALL_Z_INDEX } from 'Constants/StackingLevels';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import LogOutButton from 'Components/LogOutButton';
import { useAccountDialogShown } from 'Utils/accountDialogShown';
import { useBlockingGateHoldsBack } from 'Hooks/useHardwareBack';

const PendingDeletionModal: React.FC = () => {
  const userData = useSelector((state: MainAppReducer) => state.mainAppReducer.userData);
  const pendingDeletion = !!userData?.pending_deletion;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (pendingDeletion) {
      setOpen(true);
    }
  }, [pendingDeletion]);

  // MUS-651: an announcement that does not block the app waits while this is up.
  useAccountDialogShown(open);
  // It cannot be closed: Android's Back sends the app to the background instead of reaching the
  // screen beneath.
  useBlockingGateHoldsBack(open);

  if (!open) return null;

  return (
    <>
      <Box className="modal-outer" sx={{ zIndex: PAYWALL_BACKDROP_Z_INDEX }} />
      <Box className="modal-inner2" sx={{ zIndex: PAYWALL_Z_INDEX }}>
        <Box className="paywall-desc-container">
          <h3 className="paywall-desc-title">Account deletion pending</h3>
          <p className="paywall-desc-text">
            Your account has been scheduled for deletion. You will lose access once the deletion is
            processed. If this was a mistake, please contact support to resolve it.
          </p>
        </Box>
        <Box className="logout-container">
          <LogOutButton />
        </Box>
      </Box>
    </>
  );
};

export default PendingDeletionModal;
